/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/groups/:group_code',
    name: 'Supplier Group',
    view: 'SupplierGroup',
    meta: { public: true, standalone: true }
  },
  {
    path: '/analytics',
    // Relative to /src/views
    view: 'Analytics'
  },
  {
    // Legacy path, kept for old bookmarks and login fallbacks
    path: '/dashboard',
    redirect: '/analytics'
  },
  {
    path: '/schedule',
    view: 'Schedule'
  },
  {
    path: '/calendar',
    view: 'Calendar'
  },
  {
    path: '/item-list',
    view: 'ItemList'
  },
  {
    path: '/event-request',
    name: 'Event Request',
    view: 'EventRequest'
  },
  {
    path: '/shared-schedule',
    name: 'Shared Schedule',
    view: 'SharedSchedule',
    meta: {
      isShared: true,
      public: true
    }
  },
  {
    path: '/shared-calendar/:retail_code',
    name: 'Shared Calendar',
    view: 'SharedCalendar',
    meta: {
      isShared: true,
      public: true
    }
  },
  {
    path: '/insights',
    view: 'Insights'
  },
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'
  },
  {
    path: '/media',
    name: 'Digital Media',
    view: 'Media'
  },
  {
    path: '/events',
    view: 'Recaps'
  },
  {
    path: '/icons',
    view: 'Icons'
  },
  {
    path: '/maps',
    view: 'Maps'
  },
  {
    path: '/notifications',
    view: 'Notifications'
  },
  {
    path: '/upgrade',
    name: 'Upgrade to PRO',
    view: 'Upgrade'
  },
  { path: '/clients/:client/:key',
    name: 'Client Link',
    view: 'Analytics',
    meta: {
      dologin: true
    }
  },
  { path: '/retail/:retail/:retail_key',
    name: 'Retailer Link',
    view: 'Calendar',
    meta: {
      doRetailLogin: true
    }

  },
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
    meta: {
      public: true
    }
  },
  {
    path: '/accept-invitation',
    name: 'Set Up TastingIQ',
    view: 'AcceptInvitation',
    meta: {
      public: true,
      standalone: true
    }
  },
  {
    path: '/complete-login',
    name: 'Complete Login',
    view: 'CompleteLogin',
    meta: {
      public: true,
      standalone: true
    }
  },
  {
    path: '/welcome',
    name: 'Welcome',
    view: 'Welcome',
    meta: {
      public: true
    }
  },
  { path: '/:retail([^/]{1,2})/:retail_key([^/]{8})/analytics',
    name: 'Retail Analytics Link',
    view: 'Analytics',
    meta: {
      doRetailLogin: true
    }
  },
  { path: '/:retail([^/]{1,2})/:retail_key([^/]{8})/schedule',
    name: 'Retail Schedule Link',
    view: 'Schedule',
    meta: {
      doRetailLogin: true
    }
  },
  { path: '/:retail([^/]{1,2})/:retail_key([^/]{8})/calendar',
    name: 'Retail Calendar Link',
    view: 'Calendar',
    meta: {
      doRetailLogin: true
    }
  },
  { path: '/:retail([^/]{1,2})/:retail_key([^/]{8})/events',
    name: 'Retail Events Link',
    view: 'Recaps',
    meta: {
      doRetailLogin: true
    }
  },
  { path: '/:retail([^/]{1,2})/:retail_key([^/]{8})/item-list',
    name: 'Retail Item List Link',
    view: 'ItemList',
    meta: {
      doRetailLogin: true
    }
  },
  { path: '/:retail([^/]{1,2})/:retail_key([^/]{8})',
    name: 'Retail URL',
    view: 'Calendar',
    meta: {
      doRetailLogin: true
    }
  },
  { path: '/:client([^/]{3,5})/analytics',
    name: 'Client Analytics Link',
    view: 'Analytics',
    meta: {
      dologin: true
    }
  },
  { path: '/:client([^/]{3,5})/schedule',
    name: 'Client Schedule Link',
    view: 'Schedule',
    meta: {
      dologin: true
    }
  },
  { path: '/:client([^/]{3,5})/events',
    name: 'Client Events Link',
    view: 'Recaps',
    meta: {
      dologin: true
    }
  },
  { path: '/:client([^/]{3,5})/media',
    name: 'Client Media Link',
    view: 'Media',
    meta: {
      dologin: true
    }
  },
  { path: '/:client([^/]{3,5})/event-request',
    name: 'Client Event Request Link',
    view: 'EventRequest',
    meta: {
      dologin: true
    }
  },
  { path: '/:client([^/]{3,5})/',
    name: 'Client URL',
    view: 'Analytics',
    meta: {
      dologin: true
    }
  }

]
